<template>
  <sera-modal
    :open="open"
    type="info"
    primaryLabel="Dismiss"
    @primary-action="handleClose"
    @close="handleClose"
  >
    <template #header>
      <div>
        <h3 class="page-header-2">Unable to Unarchive Customer</h3>
      </div>
    </template>
    <div style="max-width: 400px">
      <p class="mb-4">
        This customer is a sub-customer of an archived customer.
      </p>
      <p class="mb-4">
        In order to make this customer active, you must first do one of the
        following:
      </p>
      <ul>
        <li>Unarchive the the parent.</li>
        <li>Promote this customer to be a top-level customer.</li>
        <li>Select a new parent that is not archived.</li>
      </ul>
    </div>
  </sera-modal>
</template>
<script setup lang="ts">
defineProps({
  open: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["close"]);

function handleClose() {
  emit("close");
}
</script>
